import React from 'react';

const SortDown = () => (
  <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.97266 0.625H1.97266C1.17969 0.625 0.796875 1.58203 1.34375 2.12891L4.81641 5.62891C5.17188 5.98438 5.71875 5.98438 6.07422 5.62891L9.54688 2.12891C10.1484 1.58203 9.76562 0.625 8.97266 0.625ZM5.47266 5L2 1.5H8.97266L5.47266 5Z"
      fill="currentColor"
    />
  </svg>
);

export default SortDown;
